import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  FaStar,
  FaMobileAlt,
  FaUsers,
  FaChartLine,
} from "react-icons/fa";

import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

import "./StatsSection.css";
import Common_heading from "../../common/common_heading/Common_heading";

function StatsSection() {
  const [counterOn, setCounterOn] = React.useState(false);

  const statsData = [
    {
      icon: <FaStar />,
      number: 99,
      suffix: "%",
      title: "Customer Satisfaction",
    },
    {
      icon: <FaMobileAlt />,
      number: 32,
      suffix: "M",
      title: "App Downloads",
    },
    {
      icon: <FaUsers />,
      number: 125,
      suffix: "+",
      title: "Team Members",
    },
    {
      icon: <FaChartLine />,
      number: 240,
      suffix: "%",
      title: "Company Growth",
    },
  ];

  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <section className="diligencia_stats_section">
        <div className="container">
          <Common_heading title="Our results in numbers" />

          <Row className="justify-content-center ">
            {statsData.map((item, index) => (
              <Col xs={6} lg={3} key={index} className="mb-4">
                <div className="diligencia_stats_card">
                  <div className="diligencia_stats_icon">
                    {item.icon}
                  </div>

                  <h3>
                    {counterOn && (
                      <CountUp
                        start={0}
                        end={item.number}
                        duration={3}
                        suffix={item.suffix}
                      />
                    )}
                  </h3>

                  <p>{item.title}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </ScrollTrigger>
  );
}

export default StatsSection;